import {setInitialState} from '../../../utils/reducerOperations';
export const initialState={
    getParticipationRateApi:setInitialState(),
    selectedParticipationColumns: [],
    participationColumns: [],
};